import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import theme from "../theme";
import { breakpoint } from "../utils/responsive";

import "@fontsource/poppins/100.css";
import "@fontsource/poppins/100-italic.css";
import "@fontsource/poppins/200.css";
import "@fontsource/poppins/200-italic.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/300-italic.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/500-italic.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/600-italic.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/700-italic.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/800-italic.css";
import "@fontsource/poppins/900.css";
import "@fontsource/poppins/900-italic.css";

const Text = styled.div`
  color: ${(props) =>
    props?.color ? theme?.[`${props.color}`] || props.color : theme.primary};
  text-align: ${(props) => props.textAlign};
  ${(props) => props.header && `margin-bottom: 10px;`}
  ${(props) => props.bold && `font-weight: bold;`}
  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight};`}
  ${(props) => props.breakSpaces && `white-space: break-spaces;`}
  ${(props) => props.textShadow && `text-shadow: ${props.textShadow};`}
  ${(props) => props.breakWord && `word-break: break-word;`}
  ${(props) => props.overflowWrap && `overflow-wrap: break-word;`}
  ${(props) => props.underline && `text-decoration: underline;`}
  ${(props) => props.lineThrough && `text-decoration: line-through;`}
  ${(props) => props.pointer && `cursor: pointer;`}
  font-family: ${(props) => props.condensed ? 'Poppins' : 'Poppins'};
  line-height: 1.1;
  ${(props) => props.condensed ? 'letter-spacing: -0.5px;' : ''}
  
  @media ${breakpoint.mobile} {
    font-size: ${(props) =>
      props.mFontSize
        ? `${props.mFontSize}px`
        : props.fontSize
        ? `${props.fontSize}px`
        : "16px"};
  }

  @media ${breakpoint.desktop} {
    font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : "16px")};
  }
`;

const MyTypography = (props) => {
  return <Text {...props} />;
};

export default MyTypography;

MyTypography.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
};
